import { ReviewEmail } from "./ReviewEmail";

export default ReviewEmail;
